var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInstagram = function SvgInstagram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 7.5a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9m0 7.5a3 3 0 1 1 0-5.999A3 3 0 0 1 12 15m4.5-12.75h-9A5.256 5.256 0 0 0 2.25 7.5v9a5.256 5.256 0 0 0 5.25 5.25h9a5.256 5.256 0 0 0 5.25-5.25v-9a5.256 5.256 0 0 0-5.25-5.25m3.75 14.25a3.75 3.75 0 0 1-3.75 3.75h-9a3.75 3.75 0 0 1-3.75-3.75v-9A3.75 3.75 0 0 1 7.5 3.75h9a3.75 3.75 0 0 1 3.75 3.75zM18 7.125a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0"
  })));
};
export default SvgInstagram;